import React, { useState, useEffect } from 'react';
import { Container, Paper, Box, Typography, Tabs, Tab } from '@mui/material';
import MainFormatter from './components/MainFormatter';
import Settings from './components/Settings';
import { DEFAULT_PROMPT, DEFAULT_API_KEY } from './constants';

function App() {
  const [tabValue, setTabValue] = useState(0);
  const [settings, setSettings] = useState({
    apiKey: '',
    apiUrl: 'https://api.openai.com/v1/chat/completions',
    model: 'gpt-4.1-mini',
    temperature: 0.2,
    maxTokens: 8000,
    prompt: DEFAULT_PROMPT
  });

  // Load settings from localStorage on component mount
  useEffect(() => {
    const savedSettings = localStorage.getItem('markdownFormatterSettings');
    if (savedSettings) {
      const parsed = JSON.parse(savedSettings);
      // Ensure prompt exists in loaded settings
      if (!parsed.prompt) {
        parsed.prompt = DEFAULT_PROMPT;
      }
      // Ensure new settings have default values
      if (parsed.temperature === undefined) {
        parsed.temperature = 0.2;
      }
      if (!parsed.maxTokens) {
        parsed.maxTokens = 8000;
      }
      setSettings(parsed);
    }
  }, []);

  // Save settings to localStorage when they change
  useEffect(() => {
    localStorage.setItem('markdownFormatterSettings', JSON.stringify(settings));
  }, [settings]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Create effective settings that use default API key if user hasn't set one
  const effectiveSettings = {
    ...settings,
    apiKey: settings.apiKey || DEFAULT_API_KEY
  };

  return (
    <Container maxWidth={false} sx={{ py: 2, px: 2, minHeight: '100vh' }}>
      <Paper elevation={3} sx={{ p: 2, borderRadius: 2, minHeight: 'calc(100vh - 32px)' }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          ApplyBoard Scholarship Content Markdown Formatter
        </Typography>
        
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={tabValue} onChange={handleTabChange} centered>
            <Tab label="Formatter" />
            <Tab label="Settings" />
          </Tabs>
        </Box>
        
        {tabValue === 0 && <MainFormatter settings={effectiveSettings} />}
        {tabValue === 1 && <Settings settings={settings} setSettings={setSettings} />}
      </Paper>
    </Container>
  );
}

export default App; 